import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import * as AiIcons from "react-icons/ai";
import UpdateAreaN2 from './UpdateAreaN2';
import { FaEdit } from "react-icons/fa";

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>ID área N2</th>
        <th style={{width:'20%'}}>Nombre área N2</th>
        <th className='d-none d-sm-table-cell' style={{width:'50%'}}>Descripción área N2</th>
        <th style={{width:'5%'}}>{props.mode==0?'Editar ':''}</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  
  if (props.listOfAreasN2) {
    
    const rows = props.listOfAreasN2.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.id}
          </td>
          <td>  
            {row.nombrearea}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.descripcionarea}
          </td>   
          <td align='center'>  
            {(props.mode==0) &&
              <Button variant='secondary'>
                <Link to = {`/editarean2page/${row.id}`}><FaEdit size={15} color='white'/></Link>      
              </Button>
              
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                props.onSelected(row.id,row.nombrearea,row.descripcionarea);
                props.handleClose();
              }} variant='link' value={row.id}>Seleccionar</Button>
            } 
          </td>           
          {/**
           * 
          <td align='center'>  
            {(props.mode==0) &&
              <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 400 }}
                overlay={renderEditTooltip}>        
                <UpdateAreaN2 
                  id = {row.id}
                  nombrearea = {row.nombrearea}
                  descripcionarea = {row.descripcionarea}/>    
              </OverlayTrigger>              
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                //console.log(row);
                props.onSelected(row.id,row.nombrearea,row.descripcionarea);
                props.handleClose();
              }} variant='link' value={row.id}>Seleccionar</Button>
            } 
          </td> 
          */}          

          {/**
          <td align='center'>  
            {(props.mode==0) &&
              <Link arean1id={props.arean1id} to = {`/editsublocationpage/${row.id}`}><AiIcons.AiFillEdit /></Link>      
            }
            {(props.mode==1) &&
              <Button onClick={() => {
                props.onSelected(row.id,row.sublocationinternalidentifier,row.description);
                props.handleClose();
              }} variant='link' value={row.id}>Select</Button>
            } 
          </td> 
          */}            
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);

const AreasN2List = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody mode={props.mode} handleClose={props.handleClose} onSelected={props.onSelected} arean1id={props.arean1id} listOfAreasN2={props.listOfAreasN2} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default AreasN2List;